/* Just Catnip stockists page — filter chips (design 5, 30 Sep 2026).
   Progressive enhancement: the chip row is hidden until this runs, so without JavaScript
   every stockist shows. Each chip carries data-filter="group:shops" / "region:london" / ""
   (all); tiles carry data-group and data-region. Filtering toggles the hidden attribute. */
(function () {
  function init(section) {
    var chips = section.querySelectorAll('[data-filter]');
    var tiles = section.querySelectorAll('[data-group]');
    var row = section.querySelector('.jc-stockists__chips');
    var status = section.querySelector('.jc-stockists__status');
    if (!chips.length || !tiles.length || !row) return;
    row.hidden = false;
    if (status) status.hidden = false;
    var template = status ? status.getAttribute('data-template') || '' : '';
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        var parts = chip.getAttribute('data-filter').split(':');
        var key = parts[0], val = parts[1];
        var shown = 0;
        tiles.forEach(function (tile) {
          var show = !key || tile.getAttribute('data-' + key) === val;
          tile.hidden = !show;
          if (show) shown++;
        });
        if (status) status.textContent = template.replace('[shown]', shown).replace('[total]', tiles.length);
      });
    });
  }
  function boot() { document.querySelectorAll('.jc-stockists').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.jc-stockists');
    if (section) init(section);
  });
})();
